import { Component, Input, HostBinding } from '@angular/core'
import { SeAvatarGroupAvatar } from './avatar-group-avatar'
import * as angular from 'angular'

@Component({
  standalone: false,
  selector: 'se-avatar-group',
  host: {'class': 'se-avatar-group'},
  templateUrl: './avatar-group.component.html',
})
export class SeAvatarGroupComponent {

  @Input('se-data-align-left') alignLeft: boolean = false
  @Input('se-data-align-center') alignCenter: boolean = false
  @Input('se-data-align-right') alignRight: boolean = false
  @Input('se-data-avatars') avatars: SeAvatarGroupAvatar[]
  @Input('se-data-border') border: boolean
  @Input('se-data-size') size: Number = 100
  @Input('se-data-type') type: string

  @HostBinding('class.se-avatar-group') baseClass: boolean = true
  @HostBinding('class.se-avatar-group--align-left') get alignLeftClass(): boolean {
    return !!this.alignLeft
  }
  @HostBinding('class.se-avatar-group--align-center') get alignCenterClass(): boolean {
    return !!this.alignCenter
  }
  @HostBinding('class.se-avatar-group--align-right') get alignRightClass(): boolean {
    return !!this.alignRight
  }

  public componentClass: string
  public avatarsNotShown: number
  public showCount: boolean = false
  public shownAvatars: SeAvatarGroupAvatar[]
  constructor() {
    //no-op
  }

  ngOnChanges(): void {
    this.init()
  }

  public init(): void {
    this.componentClass = this.getSizeClass()
    this.shownAvatars = this.getShownAvatars()
  }

  public getSizeClass(): string {
    return `se-avatar-group--size-${this.size.toString()}`
  }

  public getShownAvatars(): any[] {
    let shown = angular.copy(this.avatars)
    if (shown.length > 4) {
      this.showCount = true
      shown = shown.slice(0, 3)
      this.avatarsNotShown = this.avatars.length - 3
    }
    return shown.reverse()
  }

}